//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/NXObject.js";
let d=[[[0,"Rcp",1,"Routing.ControlPoint",0]],[[["num_stocks"],"GetStocks",{R_:{stocks:"Routing.Stock[]"}},0,0]],[]];
SPLM.Routing.Corner = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.Corner";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.Corner.Type = Object.freeze({
    "Bend" : "Bend", "Miter" : "Miter", "Cope" : "Cope", "Discontinuity" : "Discontinuity", "None" : "None"});

export default SPLM;